import { T } from '../strings'
import type { Theme } from '../theme'
import { MAX_FACTOR, MIN_UPTO, type Scope, type ScopeKind } from '../game/types'

interface Props {
  scope: Scope
  theme: Theme
  /** Освоенность таблицы каждой цифры — полоска под числом. */
  pctByNumber: Record<number, number>
  onChange: (scope: Scope) => void
}

const NUMBERS = Array.from({ length: MAX_FACTOR - 1 }, (_, i) => i + 2)

const KINDS: Array<{ kind: ScopeKind; label: string }> = [
  { kind: 'single', label: T.scopeSingle },
  { kind: 'upto', label: T.scopeUpto },
  { kind: 'all', label: T.scopeAll },
]

export default function ScopePicker({ scope, theme, pctByNumber, onChange }: Props) {
  const numbersOff = scope.kind === 'all'

  const switchKind = (kind: ScopeKind): void => {
    if (kind === 'all') {
      onChange({ kind, n: MAX_FACTOR })
      return
    }
    // «До 2» — это один пример 2×2, играть нечем.
    onChange({ kind, n: kind === 'upto' ? Math.max(MIN_UPTO, scope.n) : scope.n })
  }

  return (
    <div className="scope">
      <div className="label">{T.scopeTitle}</div>

      <div className="seg">
        {KINDS.map(({ kind, label }) => (
          <button
            key={kind}
            type="button"
            className="seg__item"
            aria-pressed={scope.kind === kind}
            onClick={() => switchKind(kind)}
          >
            {label}
          </button>
        ))}
      </div>

      <div className="scope__nums" aria-label={T.pickNumber} aria-disabled={numbersOff}>
        {NUMBERS.map((n) => {
          const off = numbersOff || (scope.kind === 'upto' && n < MIN_UPTO)
          const active = !numbersOff && scope.n === n
          const pct = pctByNumber[n] ?? 0

          return (
            <button
              key={n}
              type="button"
              className="num-btn"
              disabled={off}
              aria-pressed={active}
              style={{
                borderColor: active ? theme.acc : theme.line,
                background: active ? theme.acc : 'transparent',
                color: active ? theme.onacc : theme.ink,
                opacity: off ? 0.3 : 1,
              }}
              onClick={() => onChange({ kind: scope.kind, n })}
            >
              {n}
              <span className="num-btn__bar" style={{ background: theme.line }}>
                <span
                  className="num-btn__fill"
                  style={{ width: `${pct}%`, background: active ? theme.onacc : theme.acc }}
                />
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
